import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../../generic-components/Heading';
import { ReactComponent as InvoicesZeroStateIcon } from '../../../../assets/dashboard/invoices-zero-state-icon.svg';

const testIdPrefix = 'InvoicesWidget';

const STYLES = {
  ZERO_STATE_BTN:
    'w-[170px] h-[32px] text-center text-bw00 bg-action03 hover:bg-action04 active:bg-action05 rounded-[2px] shadow-widgetCard font-metricRSemibold text-[12px] flex justify-center items-center',
};

export const InvoicesWidgetZeroState = ({
  handleCreateFirstInvoiceClick,
}: {
  handleCreateFirstInvoiceClick: () => void;
}) => {
  const { t } = useTranslation('dashboardFaceliftResourcesEN');
  return (
    <div className='flex flex-col items-center justify-center h-full'>
      <InvoicesZeroStateIcon className='mt-[20px] w-[42px] h-[42px]' />
      <Heading
        title={t('INVOICES_WIDGET_ZERO_STATE_TITLE')}
        testId={`${testIdPrefix}__zero-state-title`}
        className='mt-[20px] text-bw08 font-metricRSemibold text-sm'
      />
      <Heading
        title={t('INVOICES_WIDGET_ZERO_STATE_SUBTITLE')}
        testId={`${testIdPrefix}__zero-state-subtitle`}
        className='mt-[2px] text-bw08 font-metricR text-sm mb-[20px]'
      />
      <div className='mx-auto'>
        <button
          id={`${testIdPrefix}__btn-add-bills`}
          onClick={handleCreateFirstInvoiceClick}
          className={STYLES.ZERO_STATE_BTN}
          type='button'
          data-testid={`${testIdPrefix}__btn-add-bills`}
        >
          {t('INVOICES_WIDGET_ZERO_STATE_BTN_TEXT')}
        </button>
      </div>
    </div>
  );
};
